/**
 * Author(s) : Mounika Murugeshan
 * Purpose : This component forms a layout, and it also contains Background Animation, Header, and navigation. Renders main component as a children.
 */
import styles from './PageLayout.module.scss';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { BackgroundAnimation } from '../../components';
import { FULL_SCREEN } from '../../constants/route-constants';
import { Header, LeftNav, PageContainer } from "../../container";

function PageLayout(props) {
  const [isHamburgerOpen, setHamburgerOpen] = useState(false);
  const { handleTheme, theme } = props;
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      exit={{ opacity: 0 }}>
      <BackgroundAnimation theme={theme}></BackgroundAnimation>
      <div className={styles.appWrapper}>
        <>
          {!FULL_SCREEN.includes(window.location.pathname) ? (
            <div className={styles.app}>
              <Header
                handleTheme={handleTheme}
                theme={theme}
                setHamburgerOpen={setHamburgerOpen}
                isHamburgerOpen={isHamburgerOpen}></Header>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                exit={{ opacity: 0 }}
                className={styles.wrapper}>
                <LeftNav
                  theme={theme}
                  setHamburgerOpen={setHamburgerOpen}
                  isHamburgerOpen={isHamburgerOpen}
                  handleTheme={handleTheme}></LeftNav>
                <PageContainer isHamburgerOpen={isHamburgerOpen}>
                  {props.children}
                  {/* <LogoAnimation/> */}
                </PageContainer>
              </motion.div>
            </div>
          ) : (
            <div className={styles.app}>{props.children}</div>
          )}
        </>
      </div>
    </motion.div>
  );
}
PageLayout.propTypes = {
  handleTheme: PropTypes.func,
  theme: PropTypes.string,
};
export default PageLayout;
